import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Label } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../components/Wrappers/Layout";
import val from "../../getThemeDetails";
import constants from "../../config/constants";
import { useEffect,useState } from "react";
import { resetAdminGetTransferTypeList } from "../../redux/actions/adminGetTransferTypeListAction";



function AdminFeeMaster() {
	const { t } = useTranslation();
	const history = useHistory();
	const { pathname } = useLocation();
	const dispatch = useDispatch();
	const Theme = useSelector((state) => state.theme.theme);
	const getMappedListForAdminRes = useSelector(
		({ getMappedListsForadmins }) => getMappedListsForadmins
	)
	const {
		data: { isMyBankAllowed, isMyWalletAllowed, isMyCardAllowed }
	} = useSelector(({ walletSetting }) => walletSetting);

		const [allowedSubModules, setAllowedSubModules] = useState([]);
		const partnerloginUser = useSelector(({ login }) => login);
		var authTokens = partnerloginUser.data.AuthToken;
		sessionStorage.setItem("walletOwnerId", partnerloginUser.data.partnerId);
	
		const login = useSelector(({ login }) => login);
	
		const regenerateTokenRes = useSelector(
			({ regenerateToken }) => regenerateToken
		);

	const options = [
		{
			id: 1,
			label: "Generate Key",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/Setting",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/generate key.png`,
			flag: "GENERATE KEY"

		},
		{
			id: 2,
			label: "Country Master",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/CountrySettings",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/CountryMaster.png`,
			flag: "COUNTRY MASTER",

		},
		{
			id: 3,
			label: "Bank Master",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/AdminBankMaster",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/MyBank.png`,
			flag: "BANK MASTER"

		},
		{
			id: 4,
			label: "Language Master",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/AdminLanguageMaster",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/languageMaster.png`,
			flag: "LANGUAGE MASTER"
		},
		{
			id: 5,
			label: "Bank Type",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/adminBankType",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/bankType.png`,
			flag: "BANK TYPE",
		},
		{
			id: 6,
			label: "Transfer Type",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/adminTransferType",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/transferType.png`,
			flag: "TRANSFER TYPE",
		},
		{
			id: 7,
			label: "Account Type",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/accountTypeAdmin",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/accountType.png`,
			flag: "ACCOUNT TYPE",

		},
		{
			id: 8,
			label: "Push Notification",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/AdminPushNotification",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/accountType.png`,
			flag: "PUSH NOTIFICATION",

		},
		{
			id: 9,
			label: "SMS Provider",
			route: "/index/AdminSMSProvider",
			src: `${process.env.PUBLIC_URL}/${Theme}/pinBySMS.png`,
			flag: "SMS PROVIDER",

		},
		{
			id: 10,
			label: "Activitys Tracker",
			route: "/index/ActivityTrackerAdmin",
			src: `${process.env.PUBLIC_URL}/${Theme}/CREATE PROOF TYPE.png`,
			flag: "ACTIVITY TRACKERS"

		},
		{
			id: 11,
			label: "Module Allocation",
			route: "/index/AdminModuleAllocationData",
			src: `${process.env.PUBLIC_URL}/${Theme}/kyc report.png`,
			flag: "MODULE ALLOCATION"

		},
		//   {
		//     id: 5,
		//     label: "Create Wallet",
		//     route: "/index/create-wallet",
		//     src: `${process.env.PUBLIC_URL}/${val.theme}/ApiKey.png`,
		//   },
	];


	useEffect(() => {
		console.log("in reset");
		dispatch(resetAdminGetTransferTypeList())

		return () => {
			dispatch(resetAdminGetTransferTypeList())
		}
	}, [])
	let filteredOptions = [];
	if (partnerloginUser.data.partnerId === "2" || partnerloginUser.data.partnerId === "105" || partnerloginUser.data.partnerId === "200") {
		filteredOptions = options;
	} else {
		const allowedFlags = getMappedListForAdminRes?.data?.moduleAllocationVO?.masterSubModuleMappingList || [];
		filteredOptions = options.filter(({ flag }) => allowedFlags.includes(flag));
	}

	const filteredOptns = options.filter(({ label }) => {
		// if (
		//   label === "My Cards" && !constants.visibleFlags.includes(isMyCardAllowed)
		// ) {
		//   return label !== "My Cards";
		// }
		// else if (
		//   label === "My Banks" &&  !constants.visibleFlags.includes(isMyBankAllowed)
		// )
		// {
		//   return label !== "My Banks";
		// }
		if (
			label === "My Wallets" &&
			!constants.visibleFlags.includes(isMyWalletAllowed)
		) {
			// return label !== "My Wallets";
		} else return true;
	});
	// .sort((a, b) => {
	//   return a.label > b.label ? 1 : -1;
	// });

	if (!filteredOptions.length) {
		return (
			<Layout>
				<Card className="mk-root">
					<Row className="mk-row m-auto">No My Accounts Available</Row>
				</Card>
			</Layout>
		);
	}

	const handleRoute = (route) => {
		history.push({ pathname: route, state: { from: pathname } });
	};





	return (
		<Layout>
			<Card className="mk-root">
				<Row className="mk-row">
					{filteredOptions.map(({ id, src, label, route }) => (
						<Col key={id} md={4} sm={4} xs={6}>
							<div className="mk-imageRoot" onClick={() => handleRoute(route)}>
								<div className="mk-imageContainer">
									<img className="mk-image" src={src} alt={label} />
								</div>
								<Label for={label} className="fs-14">
									{t(label)}
								</Label>
							</div>
						</Col>
					))}
					{/* {options.map(({ id, src, label, route, flag }) => {
						if (
							getMappedListForAdminRes.success &&
							getMappedListForAdminRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(flag)
						) {
							return (<Col key={id} md={4} sm={4} xs={6}>
								<div className="mk-imageRoot" onClick={() => handleRoute(route)}>
									<div className="mk-imageContainer">
										<img className="mk-image" src={src} alt={label} />
									</div>
									<Label for={label} className="fs-14">
										{t(label)}
									</Label>
								</div>
							</Col>)
						}
					})} */}
				</Row>
			</Card>
		</Layout>
	);
}

export default AdminFeeMaster;
